export default {
  camelCase(str: any) {
    str = str.charAt(0).toLowerCase() + str.slice(1)
    return str.replace(/[-_](.)/g, function(match: any, group1: any) {
      return group1.toUpperCase()
    })
  },
  snakeCase(str: any) {
    const camel = this.camelCase(str)
    return camel.replace(/[A-Z]/g, function(s: any) {
      return '_' + s.charAt(0).toLowerCase()
    })
  },
  handleSnakeToStrAndNumberCamel(str: any) {
    return str
      .split(/(?=[0-9A-Z])/)
      .join('_')
      .toLowerCase()
  },
  formatDateToChainCase(date: string) {
    if (date === undefined) return
    const targetDate = date.split('/')
    const currentYear = Number(targetDate[0])
    const currentMonth = Number(targetDate[1])
    const currentDay = Number(targetDate[2])
    const result = `${currentYear}-${currentMonth}-${currentDay}`
    return result
  },
  handleObjectKeyFormatSnake(obj: any) {
    const shapeObj: any = {}

    Object.keys(obj).forEach((objKey: string) => {
      const snakeKey = this.snakeCase(objKey)

      shapeObj[snakeKey] = obj[objKey]
    })

    return shapeObj
  },
}
